const emptyObject = Object.freeze({});

module.exports = {
  NOT_FOUND: 404,
  REDIRECT: 301,
  CAPIRS_SRC: 'https://ssp.rambler.ru/capirs_async.js',
  TOPIC_COMMENTS_ANCHOR: 'topicCommentsAnchor',

  // Ссылка на страницу профиля в рамблер ID
  PROFILE_LINK: 'https://id.rambler.ru/account/profile',

  // Изменение данных подписки в рамблер ID
  CHANGE_DATA_LINK: 'https://id.rambler.ru/account/subscriptions',
  VIDEO_PROVIDERS: ['youtube', 'videoplatform', 'vk', 'other'],
  SNIPPET_VIDEO_PROVIDERS: ['youtube', 'videoplatform'],

  INFINITY_SCROLL_TOPIC_TYPES: 'news,article,gallery,video',

  GEO_ID_COOKIE: 'geo_id',
  USER_ID_COOKIE: 'uid',

  SHTORKA_SHOWED: 'shtorka.showed',
  SWIPER_MOUNTED: 'swiperMounted',
  ZALIPUHA_CLASSNAME: 'zalipuha',
  BRANDING_CLASSNAME: 'branding',

  TELEGRAM_PROVIDER: 'telegram',

  PROMETHEUS_URL: '/atlas/metrics',
  PROMETHEUS_KEY: 'cm9vdDpBaGdldHVwb28ydm9vdGFoY2g1U2hpZThqb25vbmdlZTR3ZWUwY3Vt',

  /**
   * TODO:
   *  Разобраться, как отсюда забирать параметры сентри в ./server.js.
   *  До тех пор не забывать синхронизировать параметры dsn'ов тут и там.
   */
  SENTRY_PARAMS: {
    production: {
      key: 'bd118191ef1f42ca85a96c7e9e62a0f8',
      project: '218',
    },
    staging: {
      key: 'dd2298e5244c43e397c4a589fde34e82',
      project: '219',
    },
  },

  // Переменная в window с id старой рекомендалки
  RECOMMENDER_IDS: 'recommenderIds',

  // pubSub канал для обновление новой рекомендалки
  PUBSUB_RECOMMENDER_CHANNEL: 'recommenderIdsUpdated',

  INFINITY_TOPICS_LIMIT: 10,
  BASE_Z_INDEX: 10000, // REF: https://jira.rambler-co.ru/browse/UCMS-5469?focusedCommentId=3884307&page=com.atlassian.jira.plugin.system.issuetabpanels:comment-tabpanel#comment-3884307
  AMP_PREFIX: 'amp',

  DISCUSS_BUTTON_TEXT: 'Обсудить',

  REACT_QUERY_STATE: '__REACT_QUERY_STATE__',
  LB_SHARED_CONTEXT: '__LB_SHARED_CONTEXT__',

  EMPTY_OBJECT: emptyObject,

  VOID_QUERY: {
    queryKey: ['_void'],
    // Здесь нельзя резолвить промис значениями `null` или `undefined`,
    // т.к. это сломает обработку данных в usePrefetch
    queryFn: () => Promise.resolve(emptyObject),
    staleTime: Infinity,
    cacheTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    isLoading: false,
    initialData: emptyObject,
  },

  STORAGE_DECORATOR_WARN_PREFIX: 'Unavailable browserStorage type',
};
